import type { IconGlyph } from '../icon';

import { iconStarThick } from './star-thick';

/**
 * Tractie `star` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.5.0 — `dist/jsx/m/star.jsx`.
 */
export const iconStar: IconGlyph = {
  name: 'star',
  path: 'm21.01 8.79-5.78-.49-2.22-5.61c-.11-.27-.32-.49-.58-.61h-.01c-.56-.24-1.2.04-1.42.61L8.77 8.3l-5.78.49c-.3.02-.56.16-.75.39-.35.46-.33 1.14.13 1.55l4.42 4-1.35 5.91c-.07.29-.01.59.13.83.3.51.97.7 1.5.36l4.94-3.16 4.94 3.16c.24.15.54.22.84.13.58-.16.91-.75.79-1.32l-1.36-5.92 4.41-3.99c.7-.62.37-1.86-.62-1.94m-.05 1.2-4.85 4.38 1.48 6.48c.02.09-.04.14-.07.15 0 0-.02 0-.03-.01l-5.48-3.5L6.53 21s-.02.01-.04 0c-.02 0-.04-.02-.06-.04-.02-.03-.02-.06-.01-.08l1.49-6.5-4.86-4.39s-.03-.04-.03-.08 0-.07.03-.1l.01-.01h.02l6.41-.55 2.45-6.18s.03-.05.04-.06h.05q.03.015.06.06l2.44 6.18 6.4.55s.03 0 .04.02c.01 0 .02.03.03.05v.07c0 .02-.01.04-.04.06Z',
  selected: iconStarThick,
};
